import { Component, OnInit } from '@angular/core';
//import { default as COLORS } from '../../../BaseFramework/configs/color-schemes.json';
import COLORS from '../../../BaseFramework/configs/color-schemes.json';
import {
  CommonUtilty,UserInfoService,InteractService
} from 'app'
import { ChangeDetectorRef } from '@angular/core';
@Component({
  selector: 'app-nb-dashboard',
  templateUrl: './nb-dashboard.component.html',
  styleUrls: ['./nb-dashboard.component.scss']
})
export class NBDashboardComponent implements OnInit {
  /* Toggle */
  reportType: string = 'overall';
  fromDate = null;
  toDate = null;
  userName = null;
  cardData = null;
  constructor(
    public commonUtility: CommonUtilty,
    private userInfoService: UserInfoService,
    public changeDetectorRef: ChangeDetectorRef
    ) { }

  ngOnInit() {
    // this.onDashDataChange(2400); // onLoad
    let userInfo = {};
    userInfo = this.userInfoService.getUserInfo();
    // this.fromDate = userInfo["createdDt"];
    this.userName = userInfo["firstName"];
    this.toDate = new Date().getTime();
    this.fromDate = new Date();
    this.fromDate.setMonth(this.fromDate.getMonth() - 1);
    this.fromDate = this.fromDate.getTime();
    this.reportType = "overall"
  }


  widgetReady:boolean = true;

  /* Date */
  dateRange: any = null;
  dateRangeUnderwriterScreenBoard: any = null;
  dateRangeProductLobAnalysis: any = null;

   /* Date */
   onDashDataChange(e) {
     console.log('Range', e)
     this.fromDate = new Date(e[0]).getTime();
     this.toDate = new Date(e[1]).getTime();
     console.log("from Date", e[0])
     console.log("to Date", e[1])
     this.widgetReady = false;
     setTimeout(() => { this.widgetReady = true }, e);
   }


  /* ====================================== */
  /* UI COLOR SCHEME SELECTION AND SETTING  */
  colorSchemes = COLORS;
  colorSchemesNames = COLORS.map(i=>i.name);
  colorScheme = {
    name: 'horizon',
    selectable: true,
    group: 'Continuous',
    domain: COLORS.find(i=>i.default).scheme,
  };
  colorSchemeTempModel:any = COLORS.findIndex(i=>i.default);
  colorSchemeModelChange() {
    let temp = this.colorScheme;
    temp['domain'] = this.colorSchemes[this.colorSchemeTempModel].scheme;
    this.colorScheme = Object.assign({}, temp);
    this.changeDetectorRef.detectChanges();
    // this.onDashDataChange(900); /* Reload */
  }
  /* ====================================== */
  getSelectedCardData(){
    this.cardData = this.dataCARDS.filter(item => item)
  }

  dataCARDS: any[] = [
    {
      "name" : "Overall",
      "key" : "overall",
      "subCards" : [
        {
          "name": "Total Count",
          "value": 756,
          "breakup": [
          ]
        },
        {
          "name": "Decisioned",
          "value": 257,
          "breakup": [
          ]
        },
        {
          "name": "Pending For Customer Requirement",
          "value": 178
        },
        {
          "name": "Pending Underwriting",
          "value": 156
        },
        {
          "name": "Pending Counter Offer Acceptance",
          "value": 165
        }
      ],
    },
    {
      "name" : "Locationwise Pending",
      "key" : "Locationwise",
      "subCards": [
        {
          "name": "Total Count",
          "value": 499,
          "breakup": []
        },
        {
          "name": "Zone 1",
          "value": 211,
          "breakup": []
        },
        {
          "name": "Zone 2",
          "value": 156,
          "breakup": []
        },
        {
          "name": "Zone 3",
          "value": 56,
          "breakup": []
        },
        {
          "name": "Zone 4",
          "value": 76,
          "breakup": []
        },
      ]
    },
    {
      "name" : "Userwise Pending",
      "key" : "Userwise",
      "subCards" : [
        {
          "name": "Total Count",
          "value": 499,
          "breakup": []
        },
        {
          "name": "Adam",
          "value": 276,
          "breakup": []
        },
        {
          "name": "Travis",
          "value": 149,
          "breakup": []
        },
        {
          "name": "Harry",
          "value": 72,
          "breakup": []
        },
        {
          "name": "Taro Smith",
          "value": 2,
          "breakup": []
        },
      ]
    },

    {
      "name" : "Branchwise",
      "key" : "branchWise",
      "subCards": [
        {
          "name": "Bank of Asia Branch 1",
          
          "breakup": [
            {"Total Premium": "1,27,256"},
            {"No. of Proposals": 3},
            {"Issued": 1},
            {"Pending": 2},
          ]
        },
        {
          "name": "Bank of Asia Branch 2",
          
          "breakup": [
            {"Total Premium": "4,80,500"},
            {"No. of Proposals": 11},
            {"Issued": 5},
            {"Pending": 6},
          ]
        },
        {
          "name": "Bank of Asia Branch 3",
          
          "breakup": [
            {"Total Premium": 0},
            {"No. of Proposals": 0},
            {"Issued": 0},
            {"Pending": 0},
          ]
        }
      ]
    },
  //   {
  //     "name" : "STP Report",
  //     "key" : "STPReport",
  //     "subCards": [
  //       {
  //         "name": "Total Cases",
  //         "value": 531,
  //         "breakup": []
  //       },
  //       {
  //         "name": "Auto Underwriting",
  //         "value": 531,
  //         "breakup": []
  //       },
  //       {
  //         "name": "Manual Underwriting",
  //         "value": 531,
  //         "breakup": []
  //       },
  //       {
  //         "name": "Discrepancy",
  //         "value": 531,
  //         "breakup": []
  //       },
  //     ]
  //   }
  ];
  dataCardTypeOfProposal = [
    // {"name": "Death", "value": 98 },
    // {"name": "Critical Illness", "value": 11 },
    // {"name": "Terminal Illness", "value": 12 },
    {"name": "Retail", "value": 98 },
    {"name": "Group", "value": 11 },
  ];
  dataCardTypeOfPolicy =[
    {"name": "Individual", "value": 98 },
    {"name": "Floater", "value": 11 },
  ]
  dataCardBreakup = [
    // {"name": "Registration", "value": 16 },
    // {"name": "Adjudication", "value": 34 },
    // {"name": "Payout Approval", "value": 18 },
    // {"name": "Payout Clearance", "value": 22 },
    // {"name": "Descision Letter", "value": 31 },
    {"name": "Data Entry", "value": 16 },
    {"name": "UnderWriter", "value": 34 },
    {"name": "Payment", "value": 18 },
    {"name": "Decision Letter", "value": 22 },
  ];
  dataCardStage = [
    // {"name": "Pending", "value": 45 },
    // {"name": "Approve: Stage 1", "value": 55 },
    // {"name": "Approve: Stage 2", "value": 16 },
    // {"name": "Repudiate", "value": 3 },
    // {"name": "Inadmissible", "value": 2 },
    {"name": "Pending", "value": 45 },
    {"name": "Pending Premium", "value": 55 },
    {"name": "Approved", "value": 16 },
    {"name": "Reject", "value": 3 },
  ];


  /* Data */
  dataSet = [
    {
      name : 'Seth Green',
      claimValue : '42,50,800',
      tasks: 12,
      completed: 5,
      pendingInt: 2,
      pendingAdj: 2,
      pendingPay: 3,
      sla: 5,
    },
    {
      name : 'Evan Brown',
      claimValue : '42,50,800',
      tasks: 15,
      completed: 5,
      pendingInt: 2,
      pendingAdj: 1,
      pendingPay: 2,
      sla: 6
    },
    {
      name : 'Arnold John',
      claimValue : '42,50,800',
      tasks: 11,
      completed: 2,
      pendingInt: 2,
      pendingAdj: 1,
      pendingPay: 2,
      sla: 6
    },
    {
      name : 'Nimrod T H',
      claimValue : '42,50,800',
      tasks: 21,
      completed: 15,
      pendingInt: 2,
      pendingAdj: 1,
      pendingPay: 2,
      sla: 6
    },
    {
      name : 'Autumn James',
      claimValue : '42,50,800',
      tasks: 18,
      completed: 9,
      pendingInt: 2,
      pendingAdj: 1,
      pendingPay: 2,
      sla: 6
    },
  ];

  /* Investigator */
  dataCARDSInvestigator: any[] = [
    {
      "name": "Claims under investigation",
      "value": 121,
      "breakup": [
        {key: "Full Investigation", value: "32"},
        {key: "Basic Investigation", value: "‭18‬"},
        {key: "Document collection", value: "‭22‬"},
        {key: "Source Verification", value: "12‬"},
        {key: "Health claim investigation", value: "‭16‬"},
      ]
    },
    {
      "name": "Sub categories",
      "value": null,
      "breakup": [
        {key: "Hospital/Clinic Check", value: "23‬"},
        {key: "Nominee Check", value: "27"},
        {key: "Neighbour Checks", value: "‭16‬"},
        {key: "Employer Check", value: "‭22‬"},
        {key: "Anganwadi Check", value: "12‬"},
      ]
    },
  ];

  /* DUMMY ; change logic */
  getUserLoad(u) {
    if(u.completed/u.tasks*100 < 40) return 'low';
    else if(u.completed/u.tasks*100 < 60) return 'med';
    else return 'hig';
  }

  /* Search */
  searchTerm:string = '';

  /* Agent Search -- FAKE */
  isSearching = false;
  agentSearch() {
    this.isSearching = true;
    this.dataSet = this.Shuffle(this.dataSet); /* Fake sort */
    this.dataSet = this.dataSet.sort(() => Math.random() - 0.15 ); /* Fake sort */
    setTimeout(()=>{this.isSearching = false;},800);
  }
  Shuffle(o) {
    for(let j, x, i = o.length; i; j = parseInt(String(Math.random() * i)), x = o[--i], o[i] = o[j], o[j] = x);
    return o;
  };


  calculateAndGetPercentage(value, outOff){
    return Math.round(value / outOff * 100)
  }

  /* Toggle */
  persona: string = 'staff';



  pie = [
    {
      "name": "Life",
      "value": 40632,
      "extra": {
        "code": "de"
      }
    },
    {
      "name": "Health",
      "value": 50000,
      "extra": {
        "code": "us"
      }
    },
    {
      "name": "Motor",
      "value": 36745,
      "extra": {
        "code": "fr"
      }
    },
    {
      "name": "Travel",
      "value": 36240,
      "extra": {
        "code": "uk"
      }
    },
  ];



  onSelect(e) {
    console.log('ngx-chart',e);
  }



  /* Size */
  view: any[] | undefined = undefined;

  gradient = false;
  showLegend = false;
  showLabels: boolean = true;
  showXAxis = true;
  showXAxisLabel = true;
  showYAxis = true;
  showYAxisLabel = true;
  timeline = false;
  xAxisLabel: string = 'Months';
  yAxisLabel: string = 'Count';

  single = [
    // {
    //   "name": "Sanjay K",
    //   "value": 11
    // },
    // {
    //   "name": "Manish S",
    //   "value": 19
    // },
    // {
    //   "name": "Rahul R",
    //   "value": 9
    // },
    // {
    //   "name": "Kamlesh T",
    //   "value": 13
    // },
    // {
    //   "name": "Nupur K T",
    //   "value": 8
    // },
    // {
    //   "name": "Sumit K",
    //   "value": 21
    // },
    {
      "name":"Accept",
      "value":"70"
    },
    {
      "name":"Reject",
      "value":"30"
    },
  ];

  single1 = [
    // {
    //   "name": "Sanjay K",
    //   "value": 11
    // },
    // {
    //   "name": "Manish S",
    //   "value": 19
    // },
    // {
    //   "name": "Rahul R",
    //   "value": 9
    // },
    // {
    //   "name": "Kamlesh T",
    //   "value": 13
    // },
    // {
    //   "name": "Nupur K T",
    //   "value": 8
    // },
    // {
    //   "name": "Sumit K",
    //   "value": 21
    // },
    {
      "name":"Accept",
      "value":"60"
    },
    {
      "name":"Reject",
      "value":"40"
    },
  ];

  underwriterBoard = [
    {
      "LOB": "NBU-Health",
      "totalCases": 3190,
      "STP": 1830,
      "NSTP": 360,
      "pending": 580,
      "rated": 300,
      "declined": 220
    },
    {
      "LOB": "NBU-Life",
      "totalCases": 3190,
      "STP": 1830,
      "NSTP": 360,
      "pending": 580,
      "rated": 300,
      "declined": 220
    },
    {
      "LOB": "Claim-Health",
      "totalCases": 3190,
      "STP": 1830,
      "NSTP": 360,
      "pending": 580,
      "rated": 300,
      "declined": 220
    }
  ]

  productLobAnalysis = [
    {
      "LOB": "Health",
      "product": "Standard Health Care",
      "productID": "SHC012",
      "issuedPolicyRatio": 31,
      "referredPolicyRatio": 3,
      "rejectedPolicyRatio": 4,
      "SLABreachingRatio": 1
    },
    {
      "LOB": "Health",
      "product": "Hospital Benefit Plus",
      "productID": "HBP09",
      "issuedPolicyRatio": 23,
      "referredPolicyRatio": 6,
      "rejectedPolicyRatio": 2,
      "SLABreachingRatio": 6
    },
    {
      "LOB": "Life",
      "product": "Life Assurance Plus",
      "productID": "LAP00",
      "issuedPolicyRatio": 20,
      "referredPolicyRatio": 2,
      "rejectedPolicyRatio": 2.5,
      "SLABreachingRatio": 4
    }
  ]
  productFailedRulesAnalysis = [
    {
      "LOB": "Health",
      "product": "Standard Health Care",
      "productID": "SHC012",
      "ruleName": "Smoker and alcoholic",
      "failingRatio": 32
    },
    {
      "LOB": "Health",
      "product": "Hospital Benefit Plus",
      "productID": "HBP09",
      "ruleName": "Existing Disease",
      "failingRatio": 30
    },
    {
      "LOB": "Life",
      "product": "Life Assurance Plus",
      "productID": "LAP00",
      "ruleName": "WOP Death",
      "failingRatio": 20
    }
  ]

  multi = [
    {
      "name": "STP",
      "series": [
        {
          "name": "Jan",
          "value": 500
        },
        {
          "name": "Feb",
          "value": 800
        },
        {
          "name": "March",
          "value": 500
        }
      ]
    },
  
    {
      "name": "NSTP",
      "series": [
        {
            "name": "Jan",
            "value": 200
          },
          {
            "name": "Feb",
            "value": 300
          },
          {
            "name": "March",
            "value": 250
          }
      ]
    }
  ];
  
  // Age group Config
  
  ageGroupGradient: boolean = true;
  ageGroupShowLegend: boolean = true;
  ageGroupShowLabels: boolean = true;
  isDoughnut: boolean = false;
  legendPosition: string = 'below';
  ageGroupChart = [
    {
      "name": ">20",
      "value": 70
    },
    {
      "name": "21 - 40",
      "value": 15
    },
    {
      "name": "14 - 60",
      "value": 10
    },
    {
      "name": "61 - 75",
      "value": 3
    },
    {
      "name": ">76",
      "value": 2
    }
  ];
  
  declineReasonChart = [
    {
      "name": "R1",
      "value": 70
    },
    {
      "name": "R2",
      "value": 15
    },
    {
      "name": "R3",
      "value": 10
    },
    {
      "name": "R4",
      "value": 3
    },
    {
      "name": "Others",
      "value": 2
    }
  ];

  salesSLA = [
    {
      "name": "Achieved",
      "value": 80
    },
    {
      "name": "Missed",
      "value": 20
    }
  ];

}
